module.exports = __webpack_public_path__ + "img/starwars.e888060d.jpg";